import * as React from 'react';
import { WhiteLabelMobileCarrierSection } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { VehicleInfoState, VehicleSelectionContainer, VehicleSelectionMethod, VehicleSelectionHierarchyLabel } from "../../vehicleInfo";
import { PhotoCapture, PhotoCaptureAttributeType } from '../enums';
import { PhotoCaptureConstants, VIN_INVALID_MESSAGE } from '../constants';
import { usePhotoCaptureVinWorker } from '../hooks';
import { StyledContent, StyledActionControlsSection } from './SinglePhotoUploadComponent.style';
import { StyledVinDivContainer } from './VinDecodeComponent.style';
import { PhotoCaptureNavigationControlComponent } from './PhotoCaptureNavigationControlComponent';
export const VinDecodeComponent = ({ appTheme, questionText, warningMessage = '', vehicleInfoData = new VehicleInfoState().vehicleInfoData, answerList, isSaveSuccess, companyCode, evaluationDocId, questionnaireId, questionnaireQuestionId, contextId, isContextUpdated, isTermsAndConditionAccepted, photoCaptureAttachmentInfo, questionSubType, attachedArtifactIds, parentQuestionId, photoCaptureUpdateContextDataAction, questionnaireEvaluationQuestionGetAction, questionnaireEvaluationSaveRequestAction, photoCaptureResetContextAction, onResetVehicleInfo, onValidVinData, photoCaptureUpdateAttachedArtifactIdSuccessAction, onFlyoutClicked }) => {
    const translateFn = TranslationService.translate;
    const [vin, setVin] = React.useState((vehicleInfoData && vehicleInfoData.Vin) || '');
    const [errorMessage, setErrorMessage] = React.useState(warningMessage);
    const { moveNext, movePrevious } = usePhotoCaptureVinWorker({
        appTheme,
        questionText,
        isSaveSuccess,
        companyCode,
        evaluationDocId,
        questionnaireId,
        questionnaireQuestionId,
        questionSubType: questionSubType,
        contextId,
        isContextUpdated,
        isTermsAndConditionAccepted,
        answerList,
        photoCaptureAttachmentInfo,
        attachedArtifactIds,
        parentQuestionId,
        photoCaptureUpdateContextDataAction,
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureResetContextAction,
        photoCaptureUpdateAttachedArtifactIdSuccessAction
    });
    React.useEffect(() => {
        if (vehicleInfoData && vehicleInfoData.Vin) {
            setVin(vehicleInfoData.Vin);
            if (answerList && answerList[0].answerDisplayText) {
                const savedVehicleData = JSON.parse(answerList[0].answerDisplayText);
                if (vehicleInfoData.Vin !== savedVehicleData.Vin) {
                    setErrorMessage('');
                    onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
                }
                else {
                    if (savedVehicleData.Vehicle && savedVehicleData.Vehicle.Value) {
                        for (let item in VehicleSelectionHierarchyLabel) {
                            if (savedVehicleData[item.toString()].length > 1) {
                                const selectedItem = savedVehicleData[item.toString()].find(data => savedVehicleData.Vehicle &&
                                    savedVehicleData.Vehicle.Value[item.toString().slice(0, -1)].Id === data.Id);
                                selectedItem &&
                                    onFlyoutClicked(savedVehicleData, selectedItem, VehicleSelectionHierarchyLabel[item.toString()], VehicleSelectionMethod.VinDecode);
                            }
                        }
                    }
                }
            }
        }
        else {
            setVin('');
            onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
            setErrorMessage('');
        }
    }, [vehicleInfoData.Vin]);
    React.useEffect(() => {
        var _a, _b, _c;
        if (questionSubType === PhotoCaptureAttributeType.VIN_DECODE && answerList && answerList[0].answerDisplayText) {
            const savedVehicleData = JSON.parse(answerList && answerList[0].answerDisplayText);
            savedVehicleData.Vin &&
                onValidVinData(savedVehicleData, savedVehicleData.Vin, ((_a = savedVehicleData.Vehicle) === null || _a === void 0 ? void 0 : _a.Id) || 0, ((_c = (_b = savedVehicleData.Vehicle) === null || _b === void 0 ? void 0 : _b.Value) === null || _c === void 0 ? void 0 : _c.ServiceBarcode.toString()) || '', false);
        }
    }, [answerList]);
    React.useEffect(() => {
        setErrorMessage(warningMessage);
    }, [warningMessage]);
    const handleNext = () => {
        if (vin) {
            if (vin && vin.length !== PhotoCaptureConstants.VIN_LENGTH) {
                setErrorMessage(VIN_INVALID_MESSAGE);
            }
            else {
                onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
                moveNext(JSON.stringify(vehicleInfoData));
            }
        }
        else {
            onResetVehicleInfo(VehicleSelectionMethod.VinDecode, vehicleInfoData.Vin);
            moveNext(JSON.stringify(new VehicleInfoState().vehicleInfoData));
        }
    };
    return (React.createElement(StyledContent, null,
        React.createElement(WhiteLabelMobileCarrierSection, { headerText: appTheme.headerText, headerBackgroundColor: appTheme.headerBackgroundColor, headerColor: appTheme.headerColor, speechBoxRichText: questionText, speechBoxBackgroundColor: appTheme.speechBoxBackgroundColor, avatarUrl: appTheme.avatarUrl, avatarColor: appTheme.avatarColor, islanguageHide: true, warningMessage: translateFn(errorMessage) }),
        React.createElement(StyledActionControlsSection, null,
            React.createElement(StyledVinDivContainer, null,
                React.createElement(VehicleSelectionContainer, { isDisabled: false, shouldShowManualOption: false, t: translateFn })),
            React.createElement(PhotoCaptureNavigationControlComponent, { buttonBackgroundColor: appTheme.buttonBackgroundColor, buttonTextColor: appTheme.buttonTextColor, idPrefix: `${PhotoCapture.PHOTO_CAPTURE}_NavigationControlComponent`, shouldNextButtonDisabled: false, disabledButtonBackgroundColor: appTheme.disabledButtonBackgroundColor, disabledButtonTextColor: appTheme.disabledButtonTextColor, onLeftClick: movePrevious, onRightClick: handleNext }))));
};
//# sourceMappingURL=VinDecodeComponent.js.map